import image1 from '../../../../assets/images/work/nxr/NXR_detailed_img_1.webp';
import image2 from '../../../../assets/images/work/nxr/NXR_detailed_img_2.webp';
import image4 from '../../../../assets/images/work/nxr/NXR_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';

const Data_NXR = {
    content: (
        <>
            {/* components to be */}

            {/* content */}
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">PROBLEM</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            As NORCAT's interactive training library grew, deploying programs reliably became a
                                            challenge. Teams needed a single trusted source for production releases, while also
                                            having a safe way to enroll into early builds for testing. Without a centralized
                                            deployment platform, updates were harder to manage across sites, versions drifted,
                                            and getting the right experience onto the right PC could take more time than it
                                            should.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-6 second-column">
                                    <h4 className="heading heading-small light-2">CHALLENGES</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            The platform had to work in real-world conditions, including varied network
                                            reliability, different hardware configurations, and strict expectations for stability.
                                            We also needed a system that could scale with a growing catalog, support multiple
                                            release channels, and reduce risk when introducing new features. Most importantly,
                                            deployment could not become an extra step for developers or trainers, it had to
                                            simplify the entire pipeline from production through to delivery.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="project-content">
                <div className="project-content-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="project-content-inner">
                                    <h2 className="heading heading-large dark-1">
                                        A centralized deployment platform built to ship immersive training at scale with
                                        production stability and beta agility.
                                    </h2>

                                    <div className="paragraph dark-1">
                                        <p>
                                            NXR is NORCAT's standalone Windows application that acts as a single
                                            source for program distribution. This installer enables clients and internal teams to browse,
                                            install, update, and maintain a growing collection of interactive training
                                            experiences from one place, while keeping release channels controlled and predictable.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="single-image-wrapper">
                        <div className="single-image">
                            <img src={image1} alt="NXR project screenshot 5" loading="lazy" decoding="async" />
                        </div>
                        <div className="single-image">
                            <img src={image2} alt="NXR project screenshot 6" loading="lazy" decoding="async" />
                        </div>
                    </div>

                    <br/><br/>

                
                    <div className="single-image">
                        <img src={image4} alt="NXR project screenshot 7" loading="lazy" decoding="async" />
                    </div>
                </div>
            </div>

            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <div className="text-content-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h4 className="heading heading-small light-2">RESULTS</h4>
                                    <div className="paragraph light-1">
                                        <p>
                                            NXR gave NORCAT a centralized, scalable way to deploy immersive training
                                            worldwide. It reduced friction for clients and internal teams, improved consistency
                                            across installations, and enabled a safer release strategy by separating stable and
                                            beta channels. 
                                        </p>
                                    </div>
                                </div>

                                <div className="col-lg-5 offset-lg-1 second-column">
                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">
                                            <span>PLATFORMS</span>
                                        </h4>
                                        <div className="paragraph light-1">
                                            <p>Windows</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">
                                            <span>CLIENT</span>
                                        </h4>
                                        <div className="paragraph light-1">
                                            <p>NORCAT (Internal)</p>
                                        </div>
                                    </div>

                                    <div className="content-wrapper">
                                        <h4 className="heading heading-small light-2">ONLINE</h4>
                                        <div className="paragraph light-1">
                                            <p>
                                                <a href="https://www.norcat.org" target="_blank" rel="noreferrer">
                                                    www.norcat.org
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-content-footer">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        Have an idea?
                                        <br />
                                        Let's explore it together.
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper">
                                        <a className="button button-1" href="/Contact">
                                            Contact Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="artwork artwork-2" aria-hidden="true">
                        <img src={artwork} alt="" loading="lazy" decoding="async" />
                    </div>
                </div>
            </div>
        </>
    ),
};

export default Data_NXR;
